import { render, staticRenderFns } from "./BlogAuthorSign.vue?vue&type=template&id=3a85397a"
import script from "./BlogAuthorSign.vue?vue&type=script&lang=js"
export * from "./BlogAuthorSign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports